import { render, staticRenderFns } from "./acha.vue?vue&type=template&id=82a635e4&"
import script from "./acha.vue?vue&type=script&lang=js&"
export * from "./acha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports